import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { NewButton } from "./index";

export const RegisterCards = () => {
   const [open, setOpen] = useState(false);

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: "8b0104df-57bf-4a46-bef7-b8e2b9fad4d1",
               region: "na1",
               target: '#preregForm'
            })
         }
      });
   }, [open]);

   const cards = [
      {
         name: "EXCLUSIVE NETWORKING",
         bgColor: "#092CA8",
         img: "./assets/media/networking-e1553444570205 1 (1).png",
         content: (
            <div
               style={{ display: "flex", flexDirection: "column", paddingBottom: '2.5vh' }}
            >
               <div>Connect with early stage investors, cutting-edge innovators, and strategic partners.
               </div>
               <br />
               <b>REGISTER NOW & SAVE $400</b>
               <i>LIMITED TIME OFFER</i>
            </div>
         ),
         btnTxt: "GET YOUR TICKET",
         btnLink: "https://youngstartup.com/upcoming",
      },
      {
         name: "INSIGHTFUL CONTENT",
         bgColor: "#0A66C2",
         img: "./assets/media/venturePanels-e1553444309249 1.png",
         content:
            "Hear top tier VCs, Corporate VCs and Angel Investors discuss and debate on the key issues facing Investors and Startup founders alike.",
         btnTxt: "APPLY TO SPEAK",
         btnLink: "https://youngstartup.com/upcoming",
      },
      {
         name: "GROUNDBREAKING PITCHES",
         bgColor: '#00C2FF',
         img: "./assets/media/presentations-e1553445156295 1.png",
         content:
            "Showcasing pre-vetted venture backed, emerging and early stage companies withing multiple dediacted tracks.",
         btnTxt: "APPLY TO PRESENT",
         btnLink: "https://youngstartup.com/upcoming",
      },
   ];


   const handleClose = () => {
      setOpen(false);
   };

   const Card = ({ card }) => {


      return (
         <Paper
            elevation={20}
            sx={{
               display: "flex",
               flexDirection: "column",
               justifyContent: "center",
               gap: "10px",
               padding: window.innerWidth < 900 ? "5%" : "1.5%",
               maxWidth: window.innerWidth < 900 ? '300px' : "350px",
               minWidth: window.innerWidth < 900 && '300px',
               flex: 1,
               alignItems: "stretch",
               m: window.innerWidth < 800 ? 2 : 3,
            }}
         >
            <Stack sx={{ height: '100%' }} spacing={2}>
               <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                  <img
                     alt='registor-card'
                     src={card.img}
                     style={{ maxWidth: "100%", height: "auto", borderRadius: '10px' }}
                  />
               </div>
               <h5 style={{ textAlign: "center", flex: 1, fontWeight: '900', fontSize: window.innerWidth < 900 && '1rem', margin: '15% 0 %' }}>{card.name}</h5>
               <h5 style={{ height: '70%', fontSize: window.innerWidth < 900 ? '.9rem' : "1rem", textAlign: 'left', padding: '0% 15%' }}>{card.content}</h5>
               <NewButton name={card.btnTxt} link={card.btnLink} color={"white"} bgColor={card.bgColor} />

            </Stack>
         </Paper>
      );
   };
   return (
      <div
         style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            backgroundColor: "white",
            paddingTop: "2.5%",
            paddingBottom: "2.5%",
            paddingRight: window.innerWidth > 1350 && '5%',
            paddingLeft: window.innerWidth > 1350 && '5%'
         }}
      >
         <h1 style={{ margin: "auto", textAlign: "center", color: 'black', fontWeight: '900' }}>
            SUPERB OFFERINGS
         </h1>
         <div
            className="register-cards-container"
            style={{
               display: "flex",
               alignItems: window.innerWidth < 900 ? "center" : "stretch",
               padding: '0%',
               paddingTop: "2.5%",
               paddingBottom: "2.5%",
               margin: '0% auto',
               flexDirection: window.innerWidth < 1150 && "column",
            }}
         >
            {cards.map((card, i) => {
               return <Card key={i} card={card} />;
            })}
         </div>

         <Dialog
            open={open}
            onClose={handleClose}
         >
            <DialogContent>
               <div id="preregForm"></div>
            </DialogContent>
         </Dialog>
      </div>
   );
};
